import { auth, type SchemaResponse } from "@/modules/api/axios"
import { type EAffiliateCampaignType, ECampaignType } from "@/modules/helpers/enum"
import type { User } from "@/modules/types"

export const applyCampaign = (
  campaignId: string,
  type: ECampaignType,
  affCampaignData?: {
    phoneNumber: string
    fullName: string
    address: string
    productId?: string
    infoApplyKOC?: {
      skuId?: string
      contentTypes: EAffiliateCampaignType[]
      totalClip: string
    }
  }
) => {
  if (type.toLowerCase() === ECampaignType.COST_PER_VIEW.toLowerCase())
    return auth.post<SchemaResponse<User>>(`/kol-submissions/cpv`, {
      cpvCampaignId: campaignId
    })
  if (type.toLowerCase() === ECampaignType.AFFILIATE.toLowerCase()) {
    let payload: any = {
      affCampaignId: campaignId,
      phoneNumber: affCampaignData?.phoneNumber,
      fullName: affCampaignData?.fullName,
      address: affCampaignData?.address,
      productId: affCampaignData?.productId?.toString(),
      contentType: affCampaignData?.infoApplyKOC?.contentTypes,
      totalClip: Number(affCampaignData?.infoApplyKOC?.totalClip)
    }

    // Single SKU mode
    if (
      affCampaignData?.infoApplyKOC?.skuId !== null &&
      affCampaignData?.infoApplyKOC?.skuId !== undefined
    ) {
      payload = {
        ...payload,
        skuId: affCampaignData.infoApplyKOC.skuId
      }
    }

    return auth.post<SchemaResponse<User>>(`v1/kol-submissions/affiliate`, payload)
  }

  return auth.post<SchemaResponse<User>>(`/kol-submissions/create`, {
    campaignId
  })
}

export const applyCampaignMCQ = (
  campaignId: string,
  type: ECampaignType,
  affCampaignData?: {
    phoneNumber: string
    fullName: string
    address: string
    productId?: string
    infoApplyKOC?: {
      skus?: { skuId: string; productId: string }[]
      contentTypes: EAffiliateCampaignType[]
      totalClip: string
    }
  }
) => {
  let payload: any = {
    affCampaignId: campaignId,
    phoneNumber: affCampaignData?.phoneNumber,
    fullName: affCampaignData?.fullName,
    address: affCampaignData?.address,
    contentType: affCampaignData?.infoApplyKOC?.contentTypes,
    totalClip: Number(affCampaignData?.infoApplyKOC?.totalClip)
  }

  payload = {
    ...payload,
    skus: affCampaignData?.infoApplyKOC?.skus
  }

  return auth.post<SchemaResponse<User>>(`v1/kol-submissions/affiliate/multiple`, payload)
}

export const requestGMVChecking = () => {
  return auth.patch<SchemaResponse<{ gmv: number }>>(`user/gmv-tiktok`)
}

export const protestOverDue = ({
  kolSubmissionId,
  reason
}: {
  kolSubmissionId?: string
  reason: string
}) => {
  return auth.post<SchemaResponse<null>>(`protest-overdues`, {
    kolSubmissionId,
    reason
  })
}

export const updateSku = ({ orderSampleId, skuId }: { orderSampleId: string; skuId: string }) => {
  return auth.post<SchemaResponse<null>>(`order-samples/update-sku`, {
    orderSampleId,
    skuId
  })
}

export const getSampleApplicationStatus = (kolSubmissionId: string) => {
  return auth.get<SchemaResponse<{ isRequestRegisterSample: boolean }>>(
    `v1/kol-submissions/sample-application-status?kolSubmissionId=${kolSubmissionId}`
  )
}
